import React from "react";
import { connect } from "react-redux";
import { setCampaign } from "../redux/actions";
import { Form, FormCheck } from "react-bootstrap";

function Campaign(props) {
  return (
    <div className="form-group">
      <Form.Label>Promo / Campaign Code</Form.Label>

      {props.campaigns.length ? (
        props.campaigns.map(({ name, isSelected }) => (
          <FormCheck
            type="checkbox"
            value={name}
            checked={isSelected}
            onChange={e =>
              props.setCampaign({ name, isSelected: e.target.checked })
            }
            label={name}
            key={name}
            id={name}
          />
        ))
      ) : (
        <p>No campaign available at this time.</p>
      )}
    </div>
  );
}

export default connect(
  ({ product }) => ({
    campaigns: product.campaigns
  }),
  { setCampaign }
)(Campaign);
